var render = function render(){var _vm=this,_c=_vm._self._c;return _c('article',{staticClass:"ai-summary-card"},[_c('div',{staticClass:"ai-summary-icon"},[_c('b-icon',{attrs:{"icon":_vm.icon}})],1),_c('div',[_c('span',[_vm._v(_vm._s(_vm.label))]),_c('strong',[_vm._v(_vm._s(_vm.value))]),(_vm.hint)?_c('small',[_vm._v(_vm._s(_vm.hint))]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }